import React from 'react';
import getAllDataInParallel from '../../helpers/get-all-data-in-parallel';
import StaffsContext from './staffs-context';
import { fetchStaffs } from './staffs-api';

export default function StaffsProvider({ children }) {

  function fetchStaffsAll(params) {
    return getAllDataInParallel({
      fn: (args) => fetchStaffs({
        ...params,
        ...args,
      }),
      key: 'staffs',
    })
  }

  const state = {
    fetchStaffs,
    fetchStaffsAll,
  };

  return (
    <StaffsContext.Provider value={state}>
      {children}
    </StaffsContext.Provider>
  )
};
